{
    "save": "Save",
    "cancel": "Cancel",
    "back": "Back",
    "next": "Next",
    "submit": "Submit",
    "loading": "Loading...",
    "language": "Language",
    "languageDescription": "Choose the language for menus, buttons, and reminders.",
    "profile": {
        "title": "Profile",
        "description": "Manage your profile and settings",
        "contactDetails": "Contact Details",
        "languageGroup": "Language",
        "otherActions": "Other Actions",
        "changePassword": "Change Password",
        "logout": "Logout",
        "incompleteTitle": "Profile Incomplete",
        "incompleteMessage": "To use Patient Watch, you should first complete your profile by adding any fields marked as missing below."
    },
    "nav": {
        "diaries": "Diaries"
    }
}
